// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"422eb7bc","337":"c9d55097","453":"6aceb01b","455":"e9a9f5a2","581":"9d85a554"}[chunkId] + ".chunk.js";
};